import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/jistore_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-09662172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "navbar" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "navtitle" }
const _hoisted_5 = { class: "topBox" }
const _hoisted_6 = {
  key: 0,
  class: "numBox"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "numicon",
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "posBox" }
const _hoisted_12 = { class: "left" }
const _hoisted_13 = { class: "num" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "sintime-gift" }
const _hoisted_16 = { class: "sintime-gift-title" }
const _hoisted_17 = { class: "sintime-gift-title-left" }
const _hoisted_18 = { class: "sintime-gift-title-right" }
const _hoisted_19 = {
  key: 0,
  class: "sintime-gift-cent"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "sintime-gift-cent-box-remen" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "sintime-gift-cent-box-img" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "sintime-gift-cent-box-name ovehide" }
const _hoisted_26 = { class: "sintime-gift-cent-box-jifen ovehide" }
const _hoisted_27 = {
  key: 0,
  class: "exchanbsie flexcenter"
}
const _hoisted_28 = { class: "exchan" }
const _hoisted_29 = { class: "exchan-box" }
const _hoisted_30 = { class: "exchan-box-img" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "exchan-box-name" }
const _hoisted_33 = { class: "exchan-box-info" }
const _hoisted_34 = { class: "exchan-box-jifen" }
const _hoisted_35 = { class: "exchan-box-tis" }
const _hoisted_36 = { class: "exchan-bottom" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  class: "flexcenter propobox",
  style: {"min-height":"100vh"}
}
const _hoisted_39 = { class: "propo" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "conent" }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "subtitle" }
const _hoisted_44 = { style: {"color":"#FF1212"} }
const _hoisted_45 = { class: "Signstyle-bottom" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "vip-title" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "vip-list-class" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_icon, {
            color: "#000",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router))),
            name: "arrow-left"
          })
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('me.jfsc')), 1 /* TEXT */),
        _createElementVNode("span", {
          class: "rightText",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.nativeToNewWeb($setup.router, '/integralrule?a=0')))
        }, _toDisplayString(_ctx.$t('me.jfgza')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.lxqdyjx')), 1 /* TEXT */),
        ($setup.dayList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dayList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "numItem",
                  style: _normalizeStyle({ 'background-color': item.sign_status == 1 ? '#FFDB00' : '#130FD0' })
                }, [
                  _hoisted_7,
                  _createElementVNode("span", {
                    style: _normalizeStyle({ 'color': item.sign_status == 1 ? '##0D0D0D' : '#fff' })
                  }, _toDisplayString(item.day) + _toDisplayString(_ctx.$t('me.tian')), 5 /* TEXT, STYLE */),
                  (item.day == 4)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "bei",
                        src: $setup.jfstore_icon_2,
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_8))
                    : (item.day == 6)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "bei",
                          src: $setup.jfstore_icon_2,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_9))
                      : (item.day == 7)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: "bei",
                            src: $setup.jfstore_icon_5,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_10))
                        : _createCommentVNode("v-if", true)
                ], 4 /* STYLE */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "jfmx",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push('/IntegralDetail')))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.jfmx')), 1 /* TEXT */),
              _createVNode(_component_van_icon, { name: "arrow" })
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString($setup.signin ? $setup.signin.score : 0), 1 /* TEXT */)
          ]),
          _createElementVNode("img", {
            class: "right",
            src: $setup.ICON_SPORTS,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_14)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('me.jfdhzq')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.nativeToNewWeb($setup.router, '/integralMyStore?a=0')))
            }, _toDisplayString(_ctx.$t('me.ckwdhd')), 1 /* TEXT */),
            _createVNode(_component_van_icon, { name: "arrow" })
          ])
        ]),
        ($setup.goodsList && $setup.goodsList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goodsList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "sintime-gift-cent-box",
                  key: index,
                  onClick: ($event: any) => ($setup.exchange(item))
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("img", {
                      src: $setup.ICON_HOT,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_22)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("img", {
                      src: item.cover,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_24)
                  ]),
                  _createElementVNode("p", _hoisted_25, _toDisplayString(item.name), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_26, [
                    _createElementVNode("span", null, _toDisplayString(item.score), 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.jfci')), 1 /* TEXT */)
                  ])
                ], 8 /* PROPS */, _hoisted_20))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createVNode(_component_van_overlay, {
      show: $setup.exchangeshow,
      "z-index": "120"
    }, {
      default: _withCtx(() => [
        ($setup.exchangedata)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: $setup.exchangedata.cover,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_31)
                  ]),
                  _createElementVNode("p", _hoisted_32, _toDisplayString($setup.exchangedata.name), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_33, _toDisplayString($setup.exchangedata.info), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_34, [
                    _createElementVNode("span", null, _toDisplayString($setup.exchangedata.score) + " " + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString($setup.exchangedata.show_score) + " " + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('奖品剩余：')) + _toDisplayString($setup.exchangedata.qty_available), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", {
                    class: "vip-discount-Class",
                    onClick: $setup.vipClick
                  }, _toDisplayString(_ctx.$t('VIP折扣说明')), 1 /* TEXT */),
                  _createElementVNode("p", {
                    class: "exchan-box-duihuan",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.exchangeclick($setup.exchangedata)))
                  }, _toDisplayString(_ctx.$t('me.dh')), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('me.dhsy')), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("img", {
                    src: $setup.ICON_CLOSE,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.exchangeshow = false)),
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_37)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_van_overlay, {
      show: $setup.showSign,
      "z-index": "120"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("img", {
              src: $setup.ICON_BG,
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_40),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('me.qdcg')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_43, [
                _createTextVNode(_toDisplayString(_ctx.$t('me.jrqdhd')) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_44, "+" + _toDisplayString($setup.today_data.score), 1 /* TEXT */),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('me.jf')) + " " + _toDisplayString(_ctx.$t('me.xlqd')) + _toDisplayString($setup.today_data.sing_day) + " " + _toDisplayString(_ctx.$t('me.tian')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showSign = false))
              }, _toDisplayString(_ctx.$t('me.ckkdh')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("img", {
              src: $setup.ICON_CLOSE,
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showSign = false)),
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_46)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_van_overlay, {
      show: $setup.showVipAlertView,
      "z-index": "121",
      onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showVipAlertView = false))
    }, {
      default: _withCtx(() => [
        ($setup.exchangedata)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vip-open-class",
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t('VIP折扣')), 1 /* TEXT */),
              _createElementVNode("img", {
                src: $setup.black_close,
                class: "vip-close-class",
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showVipAlertView = false))
              }, null, 8 /* PROPS */, _hoisted_48),
              _createElementVNode("div", _hoisted_49, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.exchangedata.vip_discount, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString($setup.getVipText(item,index)), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createVNode(_component_van_button, {
                round: "",
                color: "red",
                style: {"margin-bottom":"20px"},
                onClick: $setup.jumpToVipDetailInfo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('查看VIP详情')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}